export const checkVideoOrientation = (videoElement: HTMLVideoElement | null): 'landscape' | 'portrait' | false => {
  if (videoElement) {
    const videoWidth = videoElement.videoWidth;
    const videoHeight = videoElement.videoHeight;
    const isLandscape = videoWidth >= videoHeight;
    return isLandscape ? 'landscape' : 'portrait';
  } else {
    return false;
  }
};